import axios from "@/plugins/axios";

let url = "/api/console/calculations";

export default {
    getCalculations(data){
        return axios.get(url, data).then(result => result.data);
    },
}
